import React from 'react';
import { Theme } from '@routific/hive';
import { Button, Modal, Typography } from '@routific/hive/v5';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  visible: boolean;
  ordersCount: number;
  onOk: () => void;
  onCancel: () => void;
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Theme.Spacing.mdSpacing};
`;

const WarningsList = styled.ul`
  margin: 0;
  padding-left: ${Theme.Spacing.lgSpacing};
`;

const DeletePublishedVisitConfirmModal: React.FC<Props> = ({
  visible, ordersCount, onOk, onCancel,
}) => {
  const { t } = useTranslation(['components', 'common']);

  return (
    <Modal
      size="sm"
      open={visible}
      title={t('components:deleteVisitsConfirmModal.published.title', { count: ordersCount })}
      onClose={onCancel}
      footer={(
        <>
          <Button hierarchy="tertiary" size="md" onClick={onCancel}>
            {t('common:cancel')}
          </Button>
          <Button hierarchy="primary" tone="danger" size="md" onClick={onOk}>
            {t('components:deleteVisitsConfirmModal.published.button', { count: ordersCount })}
          </Button>
        </>
      )}
      data-cy="delete-visit-confirmation-modal"
    >
      <Content>
        <Typography variant="h5" slots={{ root: 'p' }}>
          {t('components:deleteVisitsConfirmModal.published.text', { count: ordersCount })}
        </Typography>
        <Typography variant="body" slots={{ root: 'div' }}>
          {t('components:deleteVisitsConfirmModal.published.beforeDelete')}
          <WarningsList>
            <li>
              <Trans
                i18nKey="components:deleteVisitsConfirmModal.published.driverWarning"
                count={ordersCount}
                components={{ strong: <Typography variant="body-strong" slots={{ root: 'strong' }} /> }}
              />
            </li>
            <li>
              <Trans
                i18nKey="components:deleteVisitsConfirmModal.published.customerWarning"
                count={ordersCount}
                components={{ strong: <Typography variant="body-strong" slots={{ root: 'strong' }} /> }}
              />
            </li>
          </WarningsList>
        </Typography>
      </Content>
    </Modal>
  );
};

export default DeletePublishedVisitConfirmModal;
